<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="unitoverhisTab" class="nav nav-tabs" role="tablist">
           <li class="nav-item" role="presentation">
            <button id="first-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#firstUnitoverHis"
              type="button" role="tab" aria-controls="firstUnitoverHis" @click="onClickTab('1')">
              {{ $t("content.amnunitoverhis") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="second-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#secondUnitoverHis"
              type="button" role="tab" aria-controls="secondUnitoverHis" @click="onClickTab('2')">
              {{ $t("content.amnunitoverlot") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="third-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#thirdUnitoverHis"
              type="button" role="tab" aria-controls="thirdUnitoverHis" :disabled="lurc_search === ''"
              @click="onClickTab('3')">
              {{ $t("content.amnunitovermng") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="third-unitoverhis" class="nav-link" data-bs-toggle="tab" data-bs-target="#forthUnitoverHis"
              type="button" role="tab" aria-controls="forthUnitoverHis"
              @click="onClickTab('4')">
              {{ $t("content.mlotstatus") }}
            </button>
          </li>
        </ul>

        <div id="unitoverhisTabContent" class="tab-content">
          <div id="firstUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="first-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoverhis") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2 mt-1">
                    <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                    <VueDatePicker v-model="start_hdate" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="true" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-2 mt-1">
                    <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                    <VueDatePicker v-model="end_hdate" :format="format" auto-apply :teleport="true"
                      :max-date="new Date()" :enable-time-picker="true" month-name-format="long" :clearable="false"
                      :text-input="textInputOptions" fluid />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="cat_hsearch" class="form-select">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input id="ticketno" type="text" v-model="tk_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                    <material-input id="stockno" type="text" v-model="stock_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input id="lotno" type="text" v-model="lot_hsearch" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_hsearch" class="form-select">
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="mb-3" :disabled="start_hdate > end_hdate"
                      @click="loadHistoryListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ $t("buttons.sear") }}
                    </material-button>
                  </div>
                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                      @click="cancelHistoryBtn">
                      <i class="material-icons material-symbols-outlined">close</i>
                      {{ $t("buttons.canc") }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.lotno") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.amnmaker") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhis" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageH - 1) * perPageH + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.cusName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.tkRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.stockNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.lotNumber }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ row.catName }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterODStatus(row.action) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.userName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhis.length === 0">
                          <td colspan="11" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="13" style="text-align: right">Total Rows : {{ totalRows_sH }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhis.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageH" :total-items="totalRowsH"
                          :items-per-page="perPageH" @click="onClickHandlerH" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="secondUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="second-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoverlot") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                   <div class="col-lg-2  mt-0">
                    <fieldset>
                      <div class="item">
                        <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                          <label class="form-label m-0">{{ $t("content.msdate") }}</label>
                        </material-checkbox>
                        <VueDatePicker v-model="start_month" :format="format_month" auto-apply :teleport="true"
                          :max-date="max_month" month-picker :clearable="false" fluid :disabled="!time"
                          :text-input="textInputOptions_month" />
                      </div>
                    </fieldset>
                  </div>
                  
                  <div class="col-lg-2 mt-2">
                      <label class="form-label ms-0">{{ $t("content.medate") }}</label>
                      <VueDatePicker v-model="end_month" :format="format_month" auto-apply :teleport="true"
                        :max-date="max_month"  month-picker
                        :clearable="false" fluid :disabled="!time" :text-input="textInputOptions_month" />
                  </div>

                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input v-model="lot_search" id="lotno" type="text" />
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_search" class="form-select">
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2 mt-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      :disabled="(time && new Date(start_month.year, start_month.month) > new Date(end_month.year, end_month.month))" @click="loadBreakingListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.lotno") }}</th>
                          <th class="text-center">{{ $t("content.amnticall") }}</th>
                          <th class="text-center">{{ $t("content.amnallitem") }}</th>
                          <th class="text-center">
                            {{ $t("content.capprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.sellprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.amnresults") }}
                          </th>
                          <th class="text-center">{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(row, index) in listbk" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageB - 1) * perPageB + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.lotNumber }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.numOfTicket) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.salePrice) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            <span v-if="row.profitLoss > 0" style="color:green;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else-if="row.profitLoss < 0" style="color:red;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else>
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal  text-center">
                            {{ filterODStatus(row.status) }}
                          </td>

                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.edit')"
                              :disabled="row.status !== 'SCAN_OUT' && row.status !== 'ESTIMATION_COMPLETE' && row.status !== 'COMPLETE'"
                              @click="setRecode(row)">
                              <i class=" material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="success" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" title="Excel" @click="XlsxGen(row)">
                              <i class="material-icons material-symbols-outlined">table_rows</i>
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" title="PDF" @click="pdfGen(row)">
                              <i class="material-icons material-symbols-outlined">picture_as_pdf</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listbk.length === 0">
                          <td colspan="9" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sB }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listbk.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageB" :total-items="totalRowsB"
                          :items-per-page="perPageB" @click="onClickHandlerBk" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div id="thirdUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="third-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <h5>{{ $t("content.amnunitovermng") }}</h5>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="catrc_search" class="form-select" @change="setlistrc">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input id="lotno" type="text" v-model="lrc_search" disabled />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      :disabled="lrc_search === ''" @click="loadRecodeListApi()">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th class="text-center">{{ $t("content.allweight") }}</th>
                          <th class="text-center">{{ $t("content.allqty") }}</th>
                          <th class="text-center">{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listrc" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ row.tkRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.stockNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterCat(row.catUid) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterODStatus(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              @click="getworkCaseImg(row)">
                                <i class="material-icons material-symbols-outlined">photo_library</i>
                            </material-button>
                            <material-button color="warning" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                                data-bs-target="#galleryModal" id="viewGallery" v-show="false">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listrc.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sRC }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listrc.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageRC" :total-items="totalRowsRC"
                          :items-per-page="perPageRC" @click="onClickHandlerRC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="forthUnitoverHis" class="tab-pane fade" role="tabpanel" aria-labelledby="forth-unitoverhis">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.mlotstatus") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.lotno") }}</label>
                    <material-input v-model="lot_no" id="lotno" type="text" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_lotsearch" class="form-select" disabled>
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      @click="loadLotListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.lotno") }}</th>
                          <th class="text-center">{{ $t("content.amnticall") }}</th>
                          <th class="text-center">{{ $t("content.amnallitem") }}</th>
                          <th class="text-center">
                            {{ $t("content.capprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.sellprice") }}
                          </th>
                          <th class="text-center">
                            {{ $t("content.amnresults") }}
                          </th>
                          <th class="text-center">{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(row, index) in list_lot" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageL - 1) * perPageL + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.lotNumber }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.numOfTicket) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.salePrice) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            <span v-if="row.profitLoss > 0" style="color:green;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else-if="row.profitLoss < 0" style="color:red;">
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                            <span v-else>
                              {{ formatNumberDecimalString(row.profitLoss) }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal  text-center">
                            {{ filterODStatus(row.status) }}
                          </td>

                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" :title="t('buttons.edit')"
                              :disabled="row.status !== 'COMPLETE'"
                              @click="updateRowItems(row)">
                              <i class=" material-icons material-symbols-outlined">edit</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="list_lot.length === 0">
                          <td colspan="9" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sL }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listbk.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageL" :total-items="totalRowsL"
                          :items-per-page="perPageL" @click="onClickHandlerLot" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>



        </div>

        <!-- Search Customer Dialog -->
          <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.cnameth") }}</th>
                            <th>{{ $t("content.cnameen") }}</th>
                            <th>{{ $t("content.docno") }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerAfListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                            <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                            <td>{{ row.nameTh }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td colspan="2">{{ row.docNumber }}</td>
                          </tr>
                          <tr v-if="customerlist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>

                <div class="modal-footer">
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                            :items-per-page="perPageC" @click="onClickHandlerC" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>


        <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          :workcaseDetail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
          :history="'no'"  
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/>


        <!-- Gallery Modal -->
        <div id="galleryModal" class="modal fade" tabindex="-1" aria-labelledby="galleryModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="lookupImages2" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators">
                    <div class="carousel-indicators" id="demo2">
                    </div>
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages2"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#lookupImages2"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        

      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */

import ProgressSpinner from 'primevue/progressspinner';
import { reactive, computed, ref, inject, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import ExampleFive from "@/examples/ExampleOne";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import axios from "axios";
import * as st from "@/config/setting.js";

import { useLotStore } from '@/stores/lot'
import { useShopStore } from '@/stores/shop'
import { useBreakingStore } from '@/stores/breaking'
import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'
import { useDocumentStore } from '@/stores/document'
import { useRecodeStore } from '@/stores/record'
import { useCategoryStore } from '@/stores/category'
import { useShopCatOrderStore } from '@/stores/shopcatorder'


const { t } = useI18n();
const swal = inject("$swal");


const storelo = useLotStore()
const storesh = useShopStore()
const storebk = useBreakingStore()
const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()
const stored = useDocumentStore()
const storerc = useRecodeStore()
const storeco = useShopCatOrderStore()
const storec = useCategoryStore()

///// computed

const btnSearch = computed(() => t("buttons.sear"));


const currentPageB = ref(1);
const totalRowsB = ref(1);
const perPageB = ref(30);
const totalRows_sB = ref();

const loading = ref(false);
const shop_info = ref(null)


const listbk = ref([]);
const status_search = ref('');
const lot_search = ref('');
const lrc_search = ref('');
const lurc_search = ref('');
const catrc_search = ref('');
const listrc = ref([]);

const status_lotsearch = ref('COMPLETE');
const list_lot = ref([]);
const lot_no = ref('');

const currentPageL = ref(1);
const totalRowsL = ref(1);
const perPageL = ref(30);
const totalRows_sL = ref();

const currentPageH = ref(1);
const totalRowsH = ref(1);
const perPageH = ref(30);
const totalRows_sH = ref();

const currentPageRC = ref(1);
const totalRowsRC = ref(1);
const perPageRC = ref(30);
const totalRows_sRC = ref();

const listhis = ref([]);
const start_hdate = ref(new Date(new Date().setHours(0, 0, 0, 0)));
const end_hdate = ref(new Date());
const cat_hsearch = ref('');
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_hsearch = ref('');
const stock_hsearch = ref('');
const lot_hsearch = ref('');
const status_hsearch = ref('');

const customerlist = ref([])
const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const listcat_order = ref([]);
const listprint = ref([]);
const listcat_name = ref([]);

const list_odstatus = ref([
  { items: computed(() => t("content.optall")), value: '' },
  { items: computed(() => t("content.amnunitover")), value: 'BREAKING' },
  { items: computed(() => t("content.amnstateacting")), value: 'ACTIVE' },
  { items: computed(() => t("content.scanin")), value: 'SCAN_IN' },
  { items: computed(() => t("content.scanout")), value: 'SCAN_OUT' },
  { items: computed(() => t("content.evalcom")), value: 'ESTIMATION_COMPLETE' },
  { items: computed(() => t("content.status_finish")), value: 'COMPLETE' },
])

const listinfo = ref([]);
const workcaseDetail = ref(null);
const info_cat = ref('');
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const dep_ref = ref('');
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);

const images = ref([])
const images_l = ref([])

const payment_l = ref([])
const paymentE = ref('');

const time = ref(true);

const start_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});

const end_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});

const max_month = ref({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
});


const key = JSON.parse(localStorage.getItem("shop_seleted"));

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const textInputOptions_month = {
  format: 'MM/yyyy'
};


const format_month = (date) => {
  return moment(String(date)).local().format('MM/YYYY');
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}

const onserachDate = () => {
  start_month.value = ({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
  });
  end_month.value = ({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
  });
}


const onClickHandlerH = () => {
  updatePaginationHistory()
};

const onClickHandlerBk = () => {
  updatePaginationBk()
};

const onClickHandlerC = () => {
  updatePaginationC()
};

const onClickHandlerRC = () => {
  updatePaginationRC()
};

const onClickHandlerLot = () => {
  updatePaginationLot()
};

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        if (listcat_order.value.length === 0) {
          await loadDataOrderCatApi()
          loadBreakingListApi()
        }
      }
    }
  }
}

loadDataPrintApi()

async function loadDataOrderCatApi() {
  listcat_order.value = []
  listcat_name.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: key.uid
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeco.shopCatOrderListFetch(payload);
  // console.log("cat_order : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        if (list.length !== 0) {
          listcat_order.value = list[0].catOrders
          listcat_order.value = Object.values(listcat_order.value)
          for (let i = 0; i < listcat_order.value.length; i++) {
            listcat_name.value.push({ name: filterCat(listcat_order.value[i]) })
          }
          // console.log("listcat_order : " + JSON.stringify(listcat_order.value));
        }
      }
    }
  }
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}


function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}


function cancelHistoryBtn() {
  start_hdate.value = new Date();
  end_hdate.value = new Date();
  cat_hsearch.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  tk_hsearch.value = ''
  stock_hsearch.value = ''
  lot_hsearch.value = ''
  status_hsearch.value = ''
  currentPageH.value = 1
  listhis.value = []
  totalRowsH.value = 0
  totalRows_sH.value = ''
}


async function loadHistoryListApi() {

  if (cat_hsearch.value !== '' || cusUid_search.value !== '' || tk_hsearch.value !== '' || stock_hsearch.value !== '' || lot_hsearch.value !== '' || status_hsearch.value !== '') {
    currentPageH.value = 1
  }
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: moment(new Date(start_hdate.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_hdate.value)).format('YYYY-MM-DDT23:59:59'),
    catUid: cat_hsearch.value,
    cusUid: cusUid_search.value,
    tkRefNumber: tk_hsearch.value,
    stockNo: stock_hsearch.value,
    lotNumber: lot_hsearch.value,
    action: status_hsearch.value,
  };
  const payload = data;
  // console.log("lh p : " + JSON.stringify(payload));
  const response = await storebk.historyListFetch(payload);
  // console.log("lh r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhis.value = response.data.data.list
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }
};


async function updatePaginationHistory() {
  listhis.value = []
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: moment(new Date(start_hdate.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_hdate.value)).format('YYYY-MM-DDT23:59:59'),
    catUid: cat_hsearch.value,
    cusUid: cusUid_search.value,
    tkRefNumber: tk_hsearch.value,
    stockNo: stock_hsearch.value,
    lotNumber: lot_hsearch.value,
    action: status_hsearch.value,
  };
  const payload = data;
  const response = await storebk.historyListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhis.value = response.data.data.list
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }
}


async function loadBreakingListApi() {
  currentPageB.value = 1
  let start = ""
  let end = ""
  
  if (time.value === true) { 
    // 1. แปลงเป็น Date Object (วันแรกของเดือน)
    const firstDay = new Date(start_month.value.year, start_month.value.month, 1);
    // 2. หาค่าวันสุดท้ายของเดือน
    // เคล็ดลับ: ใช้ month + 1 และวันที่เป็น 0
    const lastDay = new Date(end_month.value.year, end_month.value.month + 1, 0);

    start = moment(new Date(firstDay)).format('YYYY-MM-DDT00:00:00')
    end = moment(new Date(lastDay)).format('YYYY-MM-DDT23:59:59')
  }

  let data = "";
  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: key.uid,
    groupUid: key.groupUid,
    status: status_search.value,
    lotNumber: lot_search.value,
    fromDate: start,
    toDate: end,
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  // console.log("bl : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
};


async function updatePaginationBk() {
  listbk.value = []
  let data = "";
  let start = ""
  let end = ""
  
  if (time.value === true) { 
    // 1. แปลงเป็น Date Object (วันแรกของเดือน)
    const firstDay = new Date(start_month.value.year, start_month.value.month, 1);
    // 2. หาค่าวันสุดท้ายของเดือน
    // เคล็ดลับ: ใช้ month + 1 และวันที่เป็น 0
    const lastDay = new Date(end_month.value.year, end_month.value.month + 1, 0);

    start = moment(new Date(firstDay)).format('YYYY-MM-DDT00:00:00')
    end = moment(new Date(lastDay)).format('YYYY-MM-DDT23:59:59')
  }

  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: key.uid,
    groupUid: key.groupUid,
    status: status_search.value,
    lotNumber: lot_search.value,
    fromDate: start,
    toDate: end,
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
}

async function loadLotListApi() {
  currentPageL.value = 1
  let data = "";
  data = {
    index: currentPageL.value - 1,
    size: perPageL.value,
    shopUid: key.uid,
    groupUid: key.groupUid,
    status: status_lotsearch.value.trim(),
    lotNumber: lot_no.value,
    fromDate: '',
    toDate: '',
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  // console.log("bl : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list_lot.value = response.data.data.list
        totalRowsL.value = response.data.data.ext.total
        totalRows_sL.value = formatNumberString(totalRowsL.value)
      }
    }
  }
};


async function updatePaginationLot() {
  list_lot.value = []
  let data = "";
  data = {
    index: currentPageL.value - 1,
    size: perPageL.value,
    shopUid: key.uid,
    groupUid: key.groupUid,
    status: status_lotsearch.value,
    lotNumber: lot_no.value,
    fromDate: '',
    toDate: '',
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list_lot.value = response.data.data.list
        totalRowsL.value = response.data.data.ext.total
        totalRows_sL.value = formatNumberString(totalRowsL.value)
      }
    }
  }
}


function filterODStatus(str) {
  let side = ''
  let name = list_odstatus.value.filter((c) => c.value === str);
  if (name.length > 0) {
    side = name[0].items
  }
  return side
}


async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: key.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


async function XlsxGen(item) {
  loading.value = true
  await getShopInfo()

  let data = "";
  data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    lotUid: item.uid,
    shopInfo: shop_info.value.fullname,
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/breaking/lot/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = item.lotNumber + `_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function pdfGen(item) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    lotUid: item.uid,
    shopInfo: shop_info.value.fullname,
    catOrder: listcat_order.value
  };
  // console.log('data : ' + JSON.stringify(data));
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/breaking/lot/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
  if (response.headers.get("content-type") === 'application/pdf') {

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}

async function selectCus(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  const response = await storecus.searchCustomerFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updateRowItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขสถานะรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        updateStatus(item.uid)
      }
    }
  });
}


async function  updateStatus(id) {
  let data = "";
  data = {
    uid: id,
    shopUid: key.uid,
    groupUid: key.groupUid,
    status:'ESTIMATION_COMPLETE'

  };
  const payload = data;
  // console.log('del payload : ' + JSON.stringify(payload));
  const response = await storebk.updateStatusFetch(payload);
  // console.log('del res : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadLotListApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function onClickTab(val) {
  if (val === '1') {
    if (new Date(start_hdate.value) <= new Date(end_hdate.value)) {
      currentPageH.value = 1
      totalRowsH.value = 0
      totalRows_sH.value = ''
      await loadHistoryListApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    if ((time.value === true && new Date(start_month.value.year, start_month.value.month) <= new Date(end_month.value.year, end_month.value.month))) {
      await loadBreakingListApi()
    }
    await setsecondTab()
  }else if (val === '3') {
    if (lurc_search.value !== '') {
      await loadRecodeListApi()
    }
    await setthirdTab()
  }else if (val === '4') {
    await setforthTab()
  }
}

async function setfirstTab() {
  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }


  if (document.getElementById("forth-unitoverhis")) {
    document.getElementById("forth--unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("forthUnitoverHis")) {
    document.getElementById("forthUnitoverHis").classList.remove('show', 'active')
  }

  
  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.add('show', 'active')
  }
}

async function setsecondTab() {

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

    if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("forth-unitoverhis")) {
    document.getElementById("forth--unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("forthUnitoverHis")) {
    document.getElementById("forthUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.add('show', 'active')
  }
}

async function setthirdTab() {

  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("forth-unitoverhis")) {
    document.getElementById("forth--unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("forthUnitoverHis")) {
    document.getElementById("forthUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.add('show', 'active')
  }

}


async function setforthTab() {
  if (document.getElementById("first-unitoverhis")) {
    document.getElementById("first-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverHis")) {
    document.getElementById("firstUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("third-unitoverhis")) {
    document.getElementById("third-unitoverhis").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdUnitoverHis")) {
    document.getElementById("thirdUnitoverHis").classList.remove('show', 'active')
  }

  if (document.getElementById("forth-unitoverhis")) {
    document.getElementById("forth--unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("forthUnitoverHis")) {
    document.getElementById("forthUnitoverHis").classList.add('show', 'active')
  }
}

async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.workCaseUid)

  if (workcaseDetail.value != null) {
    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          await retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        await calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}

async function getTicketImage() {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid)
    }
  }
  if (images.value.length > 0) {
    await nextTick();
    document.getElementById("detailModal").click();
    loading.value = false
  } else {
    let obj = {
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    }
    images.value.push(obj)
    await nextTick();
    document.getElementById("detailModal").click();
    loading.value = false
  }
}

async function getFileImg(imageUid, uid) {
  let data = "";
  data = {
    shopUid: key.uid,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await stored.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: file.type,
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}


function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


async function getworkCaseInfo(id) {
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: key.groupUid,
    shopUid: key.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}


async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}


async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item,
  };
  const payload = data;
  // const response = await store.dispatch("unitUpdateFetch", payload);

  const response = await storepay.paymentGroupInfoAdminFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}

function setlistrc() {
  listrc.value = []
  currentPageRC.value = 1
  totalRowsRC.value = 0
  totalRows_sRC.value = ''
}


async function setRecode(item) {
  lurc_search.value = item.uid
  lrc_search.value = item.lotNumber
  catrc_search.value = ''
  listrc.value = []
  currentPageRC.value = 1
  totalRowsRC.value = 0
  totalRows_sRC.value = ''
  await loadRecodeListApi()
  await setthirdTab()
}


async function loadRecodeListApi() {
  let data = "";
  data = {
    index: currentPageRC.value - 1,
    size: perPageRC.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    lotUid: lurc_search.value,
    catUid: catrc_search.value,
    stockNumber: "",
    status: '',
  };
  const payload = data;
  // console.log("rcl p : " + JSON.stringify(payload));
  const response = await storerc.recordListFetch(payload);
  // console.log("RecodeList r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrc.value = response.data.data.list
        totalRowsRC.value = response.data.data.ext.total
        totalRows_sRC.value = formatNumberString(totalRowsRC.value)
      }
    }
  }
}

async function updatePaginationRC() {

  let data = "";
  data = {
    index: currentPageRC.value - 1,
    size: perPageRC.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    lotUid: lurc_search.value,
    catUid: catrc_search.value,
    stockNumber: "",
    status: '',
  };
  const payload = data;
  const response = await storerc.recordListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrc.value = response.data.data.list
        totalRowsRC.value = response.data.data.ext.total
        totalRows_sRC.value = formatNumberString(totalRowsRC.value)
      }
    }
  }
}


async function getworkCaseImg(item) {
  loading.value = true
  let workcase = null
  let data = "";
      data = {
      uid: item.workCaseUid,
      groupUid:key.groupUid,
      shopUid: key.uid,
  };
    const payload = data;

    const response = await storewc.workCaseinfoAdminFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase = response.data.data
        if (workcase.ticket.images.length > 0) {
          images.value = []
          for (let i = 0; i < workcase.ticket.images.length; i++) {
            await getFileImg(workcase.ticket.images[i].imageUid, workcase.ticket.images[i].uid)
          }
          if (images.value.length > 0) {
              setGallery2()
              document.getElementById("viewGallery").click();
              loading.value = false
            } else {
              let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
              }
              images.value.push(obj)
              setGallery2()
              document.getElementById("viewGallery").click();
              loading.value = false
            }
        }
      }
    }
  }
}


function setGallery2() {
  var i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages2" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages2" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;

}


async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}



onMounted(() => {

  if (document.getElementById("second-unitoverhis")) {
    document.getElementById("second-unitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitoverHis")) {
    document.getElementById("secondUnitoverHis").classList.add('show', 'active')
  }

  if (document.getElementById("second-saveunitoverhis")) {
    document.getElementById("second-saveunitoverhis").classList.add('show', 'active')
  }

  if (document.getElementById("secondSaveUnitoverHis")) {
    document.getElementById("secondSaveUnitoverHis").classList.add('show', 'active')
  }

});


</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

body {
  overflow-y: auto
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-12 {
  font-size: 0.75rem;
}
</style>
